/* eslint-disable no-dupe-keys */
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  imgPromptContainer: {
    height: 360,
    width: '100%',
    borderRadius: '8px',
    background: theme.palette.grey[300],
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    overflow: 'hidden',
    position: 'relative',
    border: 'none',
    background: 'transparent',
    padding: 0,
    outline: 'none',
    '&:focus': {
      border: '3px solid white',
      outline: '3px solid black',
    },
    [theme.breakpoints.up('lg')]: {
      height: 612,

      '&.isNested': {
        height: 360,
      },
    },
  },
  modalVideoPlayIcon: {
    width: 50,
    height: 50,
    borderRadius: '100rem',
    padding: 10,
    position: 'absolute',
    zIndex: 2,
    background: 'white',
    display: ({ hideVideo }) => (hideVideo ? 'none' : 'flex'),
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'hand',
    cursor: 'pointer',
    '& svg': {
      marginLeft: 2,
    },
    '& svg path': {
      fill: theme.palette.primary.dark,
    },
  },
  modalHeader: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  modalVideoImg: {
    height: '100%',
    width: '100%',
    objectFit: 'cover',
    cursor: ({ hideVideo }) => (hideVideo ? 'initial' : 'pointer'),
  },
  modalContainer: {
    backgroundColor: 'rgba(0, 0, 0, .25)',
    height: 'auto',
    width: '100%',
    '&>div': {
      '&>div': {
        borderRadius: '8px',
        width: '100%',
        maxHeight: '1200px',
        maxWidth: 1080,
        [theme.breakpoints.only('xs')]: {
          width: '90vw',
          height: 'auto',
        },
      },
    },
  },
  modal: {
    width: '100%',
    height: 'auto',
    overflow: 'hidden',
    border: '8px solid white',
    paddingBottom: '8px',
    overflow: 'hidden',
    '& video': {
      width: '100%',
    },
    borderBottom: 'none',
  },
}))

export default useStyles
